// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar-3mw2w","link":"link-11YJ_","sidebar__item":"sidebar__item-3y1he","item__text":"item__text-Tkrj0","sidebar__item_selected":"sidebar__item_selected-2oB2P"};